import { AddressProperties } from '../screens/group/types/group.type';

export function generateAddress(address?: AddressProperties) {
  if (!address || Object.keys(address).length === 0) {
    return 'N/A';
  }

  const addressParts = [
    address.address,
    address.district?.value,
    address.city?.value,
    address.province?.value,
  ]
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .filter(Boolean);

  return addressParts.length ? addressParts.join(', ') : 'N/A';
}
